const init = () => {
  const linkArrows = document.querySelectorAll('.js-linkArrow');

  if (linkArrows.length === 0) return;

  linkArrows.forEach((linkArrow) => {
    const linkArrowFrame = linkArrow.closest('.js-linkArrowFrame');
    if(!linkArrowFrame) return;

    linkArrow.addEventListener('mouseenter', (e) => {
      linkArrowFrame.classList.add('is-hover');
    });
    linkArrow.addEventListener('mouseleave', (e) => {
      linkArrowFrame.classList.remove('is-hover');
    });
  });
};

export {
  init,
};